import {
  FaRulerCombined,
  FaBed,
  FaBath,
  FaCar,
  FaGlobeAmericas,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { BiDollar } from 'react-icons/bi';
import { GiFamilyHouse } from 'react-icons/gi';
import { TbGardenCart, TbToolsKitchen2 } from 'react-icons/tb';
import { MdOutlineHouse } from 'react-icons/md';
import { IoShieldCheckmarkOutline } from 'react-icons/io5';

export const AreaIcon = FaRulerCombined;
export const BedroomsIcon = FaBed;
export const BathroomsIcon = FaBath;
export const GarageIcon = FaCar;
export const PriceIcon = BiDollar;
export const FloorIcon = GiFamilyHouse;
export const YardsIcon = TbGardenCart;
export const CityIcon = FaGlobeAmericas;
export const LocationIcon = FaMapMarkerAlt;
export const KitchenIcon = TbToolsKitchen2;
export const HouseIcon = MdOutlineHouse;
export const StateIcon = IoShieldCheckmarkOutline;
